import React, {useState} from 'react';
import {Box, Grid2, Link} from "@mui/material";
import {useNavigate} from "react-router-dom";

export const BirdhouseElement = ({data}) => {
    const [hovered, setHovered] = useState(false);
    const navigate = useNavigate();
    const defaultCameraView = "birdhouse?id=" + data.id + "&view=cameras";

    return (
        <Grid2
            key={data.id}
            style={{
                minWidth: '300px',
                maxWidth: '300px',
                flexGrow: 1,
                position: 'relative',
                zIndex: 'auto',
                transform: hovered ? 'scale(1.1)' : 'scale(1)',
                transition: 'transform 0.1s ease-in-out',
                cursor: hovered ? 'pointer' : 'default',
            }}
            onClick={() => navigate(defaultCameraView)}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            <Box
                component="img"
                sx={{
                    borderRadius: '5px',
                    height: '225px',
                    display: 'flex',
                    justifySelf: 'center',
                    objectFit: 'cover',
                }}
                alt="Birdhouse image"
                src={`data:image/png;base64,${data.miniature_pic}`}
            />
            <Link href={defaultCameraView}>{data.id}) {data.name}</Link>
        </Grid2>
    );
};